var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noBookBox"},[_c('p',[_vm._v("您还没有"+_vm._s(_vm.name)+"过任何书籍，赶快去"+_vm._s(_vm.name)+"吧!")])])}
var staticRenderFns = []

export { render, staticRenderFns }